module.exports = __webpack_public_path__ + "img/card_informe_acomodos_razonables.895a6c24.svg";